import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentActor } from 'src/app/models/actors';

@Component({
  selector: 'app-reviewandsenddocumentslistitem',
  templateUrl: './reviewandsenddocumentslistitem.component.html'
})
export class ReviewandsenddocumentslistitemComponent {

  @Input('document') document: any;
  @Input('documentIndex') documentIndex: number = 0;
  @Input('actors') actors: DocumentActor[] = [];
  @Output('openPreview') openpreview = new EventEmitter();
  actions: String[] = [];
  translations = <any>{};

  constructor(public translateService: TranslateService) {
    // Must not be empty. It's approved by a comment.
  }

  async openPreview(){
    let event:any = {
      document: this.document,
      actor: null
    }
    this.openpreview.emit(event);
  }
}
